import { Component, React } from '../../react';
import { ElementMarker } from '../../shared/elementMarker';

import cx from './style.less';

export interface IHighlightProps {
    className?: string;
    itemClassName?: string;
    activeIndex: number;
}
export default class Highlight extends Component<IHighlightProps, any> {
    public state = {
        el: null as HTMLElement,
    };

    public render() {
        const buttons = (
                /* tslint:disable */
                this.props.children as Array<React.ReactElement<any>>
                /* tslint:enable */
            ).qSelect((el, idx) => {
            if (idx === this.props.activeIndex) {
                return <span key={idx} className={cx('wrapper', this.props.itemClassName)} ref={this.updateElement}><el.type {...el.props} /></span>;
            }
            return <span key={idx} className={cx('wrapper', this.props.itemClassName)}><el.type {...el.props} /></span>;
        });

        return (
            <div className={cx('highlight', this.props.className)}>
                {buttons}
                <ElementMarker track={this.state.el} />
            </div>
        );
    }

    private updateElement = (el: HTMLElement) => {
        if (el !== this.state.el) {
            this.setState({ el });
        }
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/tabs/highlight.tsx